import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import DailyMenuSection from "./components/DailyMenuSection";
import ProposteEstiveSection from "./components/ProposteEstiveSection";
import MenuSection from "./components/MenuSection";
import GallerySection from "./components/GallerySection";
import WineSection from "./components/WineSection";
import ReviewsSection from "./components/ReviewsSection";
import HoursSection from "./components/HoursSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#121212]">
      <Header />
      <main>
        <HeroSection />
        <ProposteEstiveSection />
        <AboutSection />
        <DailyMenuSection />
        <MenuSection />
        <GallerySection />
        <WineSection />
        <ReviewsSection />
        <HoursSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
